import { useState } from 'react';

export interface OpenModalHookType {
    modalOpen: boolean;
    toggle: () => void;
    open: () => void;
    close: () => void;
}

const useOpenModal = () => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const toggle = () => {
        setModalOpen(!modalOpen);
    };

    const open = () => {
        setModalOpen(true);
    };

    const close = () => {
        setModalOpen(false);
    };

    return {
        modalOpen,
        toggle,
        open,
        close
    };
};

export default useOpenModal;
